import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useRef, useState } from "react";

const CustomArrow = ({ direction, onClick, disabled }) => {
  if (disabled) return null;
  return (
    <button
      onClick={onClick}
      className={`absolute top-1/2 -translate-y-1/2 z-20 w-10 h-10 md:w-12 md:h-12 rounded-full bg-black/40 hover:bg-black/60 transition-all duration-200 flex items-center justify-center border-none cursor-pointer shadow-md ${
        direction === "prev" ? "left-[-10px]" : "right-[-10px]"
      }`}
    >
      <FontAwesomeIcon
        icon={direction === "prev" ? faChevronLeft : faChevronRight}
        className="text-white text-lg"
      />
    </button>
  );
};

export const DashboardCarousel = ({ items, renderItem }) => {
  const scrollRef = useRef(null);
  const [showLeft, setShowLeft] = useState(false);
  const [showRight, setShowRight] = useState(false);
  const [slidesToShow, setSlidesToShow] = useState(5);

  const updateArrowState = () => {
    const scrollContainer = scrollRef.current;
    if (!scrollContainer) return;

    setShowLeft(scrollContainer.scrollLeft > 0);
    setShowRight(
      scrollContainer.scrollLeft + scrollContainer.clientWidth < scrollContainer.scrollWidth - 1
    );
  };

  const updateSlidesToShow = () => {
    const width = window.innerWidth;

    if (width >= 1400) setSlidesToShow(5);
    else if (width >= 1024) setSlidesToShow(4);
    else if (width >= 640) setSlidesToShow(3);
    else setSlidesToShow(2);
  };

  const scroll = (direction) => {
    const scrollContainer = scrollRef.current;
    if (!scrollContainer) return;

    scrollContainer.scrollBy({
      left: direction === "left" ? -scrollContainer.clientWidth : scrollContainer.clientWidth,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    updateSlidesToShow();
    updateArrowState();
  }, [items]);

  useEffect(() => {
    const handleResize = () => {
      updateSlidesToShow();
      updateArrowState();
    };

    const scrollContainer = scrollRef.current;

    window.addEventListener("resize", handleResize);
    if (scrollContainer) scrollContainer.addEventListener("scroll", updateArrowState);

    return () => {
      window.removeEventListener("resize", handleResize);
      if (scrollContainer) scrollContainer.removeEventListener("scroll", updateArrowState);
    };
  }, []);

  return (
    <div className="relative">
      <div ref={scrollRef} className="flex overflow-x-auto snap-x snap-mandatory no-scrollbar">
        {items.map((item, idx) => (
          <div
            key={item.id || idx}
            className="flex-shrink-0 snap-start"
            style={{
              width: `calc((100% - ${16 * (slidesToShow - 1)}px)/${slidesToShow})`,
            }}
          >
            {renderItem(item, idx)}
          </div>
        ))}
      </div>
      <CustomArrow direction="prev" onClick={() => scroll("left")} disabled={!showLeft} />
      <CustomArrow direction="next" onClick={() => scroll("right")} disabled={!showRight} />
    </div>
  );
};
